import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import RouteValidatorService from 'src/services/route-validation/RouteValidation.service';
import { getUser, GetUserAction } from 'src/actions/user/get/GetUser.actions';
import User from 'src/entities/User';
import * as getUserTypes from 'src/actions/user/get/Types';
import { RouteValidation } from 'src/services/route-validation/RouteValidator';
import { Redirect } from 'react-router';
import { isNullOrUndefined } from 'util';

interface StateProps {
  loggedUserData: number | null;
  user: User | undefined;
}

interface OwnProps {
  // tslint:disable-next-line:no-any
  permissions: RouteValidation[];
  exact: boolean;
  path: string;
}

interface DispatchProps {
  getUser(userId: number): Promise<GetUserAction>;
}

interface Props extends StateProps, OwnProps, DispatchProps {
}

interface State {
  willRedirect?: boolean;
}

class PrivateRoute extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  // check validations before render
  public componentWillMount(): void {
    if (this.props.user) {
      const validations = RouteValidatorService.validate(this.props.permissions);
      validations.then(() => {
        this.setState({willRedirect: false});
      }).catch(() => {
        this.setState({willRedirect: true});
      });

    } else {
      this.props.getUser(this.props.loggedUserData!).then(response => {
        if (response.type === getUserTypes.GET_USER_SUCCESS) {
          const validations = RouteValidatorService.validate(this.props.permissions!);

          validations.then(() => {
            this.setState({willRedirect: false});
          }).catch(() => {
            this.setState({willRedirect: true});
          });

        }

      }).catch(() => {
        this.setState({willRedirect: true});
      });
    }
  }

  public render(): React.ReactNode {
    if (isNullOrUndefined(this.state.willRedirect)) {
      return null;
    }
    return (
      this.state.willRedirect ?
        <Redirect to={{pathname: '/'}}/> :
        (this.props.children)
    );
  }

}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => ({
  getUser: (userId: number): Promise<GetUserAction> => (
    dispatch(getUser(userId))
  ),
});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState):
  StateProps => ({
  loggedUserData: state.authentication.loggedUserData,
  user: state.getUser.user,
});

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);


// WEBPACK FOOTER //
// ./src/modules/commons/private-route/PrivateRoute.tsx